import { render, staticRenderFns } from "./AdminTicketShowTabular.vue?vue&type=template&id=7622181a&"
import script from "./AdminTicketShowTabular.vue?vue&type=script&lang=ts&"
export * from "./AdminTicketShowTabular.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTicketShowTabular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
